var _path, _ellipse, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserAvatar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 28,
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 14C0.5 6.26801 6.76801 0 14.5 0C22.232 0 28.5 6.26801 28.5 14C28.5 21.732 22.232 28 14.5 28C6.76801 28 0.5 21.732 0.5 14Z",
  fill: "#CECBF3"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.64118,
  cy: 9.19126,
  rx: 1.57206,
  ry: 1.57206,
  transform: "rotate(17.2483 9.64118 9.19126)",
  fill: "black"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.4176,
  cy: 12.2265,
  rx: 1.57206,
  ry: 1.57206,
  transform: "rotate(17.2483 19.4176 12.2265)",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8137 10.7333L12.0347 16.0237C11.4534 17.1304 12.0185 18.4931 13.2123 18.8638L14.8638 19.3765",
  stroke: "white",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-avatar.f550af6adb2374dea9f5068d0a3e45d4.svg";